<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap>
      <v-flex lg4 sm6 xs12>
        <v-text-field
          type="text"
          label="Nombre"
          v-model="value.nombre"
          v-validate="'required'"
          data-vv-name="nombre"
          :error-messages="errors.collect('nombre')"
          :disabled="!canModifyDatosParticulares"></v-text-field>
      </v-flex>

      <v-flex lg4 sm6 xs12>
        <v-text-field
          label="Apellido"
          v-model="value.apellido"
          v-validate="'required'"
          data-vv-name="apellido"
          :error-messages="errors.collect('apellido')"
          :disabled="!canModifyDatosParticulares"></v-text-field>
      </v-flex>

      <v-flex lg4 class="hidden-md-and-down"> </v-flex>

      <v-flex lg2 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoDocumentoId"
          :items="listTiposDocumento"
          item-text="descripcion"
          item-value="id"
          label="Tipo Doc."
          :menu-props="{ minWidth: '200' }"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-text-field
          label="Documento"
          v-model="value.documento"
          v-validate="'required'"
          data-vv-name="documento"
          :disabled="!canModifyDatosParticulares"></v-text-field>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoSexoId"
          :items="listSexos"
          item-text="descripcion"
          item-value="id"
          label="Sexo"
          :menu-props="{ minWidth: '200' }"
          :disabled="!canModifyDatosParticulares"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-text-field
          label="Cuenta/Legajo"
          v-model="value.cuenta"></v-text-field>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-text-field
          label="Cuil"
          v-model="value.cui"
          mask="##-########-#"
          clearable
          v-validate="'required'"
          data-vv-name="cuil"
          :disabled="!canModifyDatosParticulares">
          <template v-slot:prepend>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="calcularCui">help_outline</v-icon>
              </template>
              Calcular Cuil en base a Documento y Sexo
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-text-field
          label="Fecha Nacimiento"
          v-model="value.fechaNacimiento"
          type="date"
          prepend-icon="event"
          v-validate="'required'"
          data-vv-name="fecha de nacimiento"></v-text-field>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoEstadoCivilId"
          :items="listEstadosCiviles"
          item-text="descripcion"
          item-value="id"
          label="Estado Civil"
          :menu-props="{ minWidth: '200' }"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoNacionalidadId"
          :items="listNacionalidades"
          item-text="descripcion"
          item-value="id"
          label="Nacionalidad"
          :menu-props="{ minWidth: '200' }"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoIvaPersonaId"
          :items="listTiposIva"
          item-text="descripcion"
          item-value="id"
          label="Condición IVA"
          :menu-props="{ minWidth: '200' }"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoSituacionLaboralId"
          :items="listSituacionesLaborales"
          :hint="hintSituacionLaboral"
          persistent-hint
          item-text="descripcion"
          item-value="id"
          label="Actividad Laboral Principal"
          :menu-props="{ minWidth: '200' }"></v-autocomplete>
      </v-flex>

      <v-flex lg2 sm6 xs12>
        <v-text-field
          label="No. Asociado"
          v-model="value.numeroAsociado"
          disabled
          :hint="infoAsociacion"
          persistent-hint></v-text-field>
      </v-flex>

      <v-flex lg2 sm6 xs12>
        <v-checkbox
          v-model="value.asignarNumeroAsociado"
          label="Asignar No. Asociado"
          v-if="
            value.id == '00000000-0000-0000-0000-000000000000'
          "></v-checkbox>
      </v-flex>

      <v-flex
        lg2
        sm6
        xs12
        v-show="value.asociadoDesde != null && !value.asociadoHasta">
        <v-btn color="red" small dark @click="bajaSocio">Baja Socio</v-btn>
      </v-flex>

      <v-flex lg2 class="hidden-md-and-down"> </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-autocomplete
          v-model="value.tipoPersonaId"
          :items="listTiposPersona"
          :hint="hintSituacionLaboral"
          persistent-hint
          item-text="descripcion"
          item-value="id"
          label="Tipo Persona"
          :menu-props="{ minWidth: '200' }"></v-autocomplete>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-checkbox
          label="Sujeto Obligado"
          v-model="value.sujetoObligado"
          hint="Sujeto Obligado"
          persistent-hint></v-checkbox>
      </v-flex>

      <v-flex lg3 sm6 xs12>
        <v-checkbox
          label="PEP"
          v-model="value.pep"
          hint="Persona Políticamente Expuesta"
          persistent-hint></v-checkbox>
      </v-flex>

      <v-flex>
        <v-layout>
          <v-flex>
            <app-manejo-domicilios
              propName="domicilios"
              :value="value"
              :permitirAgregar="
                value.domicilios.length == 0
              "></app-manejo-domicilios>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";

import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      listTiposDocumento: [],
      listNacionalidades: [],
      listSexos: [],
      listTiposIva: [],
      listSituacionesLaborales: [],
      listEstadosCiviles: [],
      hintSituacionLaboral: "",
      listTiposPersona: [],
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.loadTiposDocumento();
    this.loadNacionalidades();
    this.loadEstadosCiviles();
    this.loadTiposIva();
    this.loadSituacionesLaborales();
    this.loadSexo();
    this.loadTiposPersona();
  },
  computed: {
    ...mapGetters(["checkCanAccess"]),
    canModifyDatosParticulares: function () {
      return this.checkCanAccess("ap-modifica-datos-particulares-legajo");
    },

    infoAsociacion: function () {
      if (this.value.asociadoDesde && !this.value.asociadoHasta) {
        return (
          "Desde el " + new Date(this.value.asociadoDesde).toLocaleDateString()
        );
      }

      if (this.value.asociadoDesde && this.value.asociadoHasta) {
        return (
          "Entre el " +
          new Date(this.value.asociadoDesde).toLocaleDateString() +
          " y el " +
          new Date(this.value.asociadoHasta).toLocaleDateString()
        );
      }

      return "No Asociado";
    },
  },
  watch: {
    "value.nombre": function () {
      if (this.value) this.value.nombre = this.value.nombre.toUpperCase();
    },
    "value.apellido": function () {
      if (this.value) this.value.apellido = this.value.apellido.toUpperCase();
    },
    "value.tipoSituacionLaboralId": function () {
      if (this.value) this.setHintSituacionLaboral();
    },
  },

  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async calcularCui() {
      this.loading = true;
      try {
        var result = await http.put(
          "personas/calcularcui",
          JSON.stringify({
            documento: this.value.documento,
            sexoId: this.value.tipoSexoId,
          })
        );
        this.value.cui = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    setHintSituacionLaboral() {
      var hint = "";
      for (
        let index = 0;
        index < this.listSituacionesLaborales.length;
        index++
      ) {
        const item = this.listSituacionesLaborales[index];
        if (item.id == this.value.tipoSituacionLaboralId) {
          if (item.anulado == true)
            hint = "La situación está anulada, intente cambiar por una activa";

          if (item.requiereEmpleo) {
            if (hint != "") hint = hint + " y además, ";

            hint = hint + "La situación requiere el ingreso de datos laborales";
          }
        }
      }

      this.hintSituacionLaboral = hint;
    },
    async loadTiposDocumento() {
      this.loading = true;
      try {
        var result = await http.get("tiposdocumento"); // traigo todas
        this.listTiposDocumento = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadNacionalidades() {
      this.loading = true;
      try {
        var result = await http.get("tiposnacionalidad"); // traigo todas
        this.listNacionalidades = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadTiposPersona() {
      this.loading = true;
      try {
        var result = await http.get("tiposPersona"); // traigo todas
        this.listTiposPersona = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadEstadosCiviles() {
      this.loading = true;
      try {
        var result = await http.get("tiposestadocivil"); // traigo todas
        this.listEstadosCiviles = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposIva() {
      this.loading = true;
      try {
        var result = await http.get("tiposivapersona"); // traigo todas
        this.listTiposIva = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales"); // traigo todas
        this.listSituacionesLaborales = result.list;

        this.setHintSituacionLaboral();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSexo() {
      this.loading = true;
      try {
        var result = await http.get("tipossexo"); // traigo todas
        this.listSexos = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async bajaSocio() {
      let res = await this.$dialog.confirm({
        text: "",
        title: "¿Confirma la baja de la Asociación?",
      });

      if (res != false) {
        try {
          this.saving = true;
          var result = await http.post(
            "personas/bajaAsociacion",
            JSON.stringify({ personaId: this.value.id })
          );
          this.alertSuccess("Los cambios han sido guardados.");
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.saving = false;
      }
    },
  },
};
</script>

<style></style>
